/* eslint-disable @calm/react-intl/missing-formatted-message */
import React from 'react';
import ReactPlayer from 'react-player';
import styled from 'styled-components';
import {
  CpHeading03Primary,
  CpBody01Secondary,
  CpBody03Primary,
  CpBody03Placeholder,
} from 'components/atoms/customer-portal/typography';
import { useGetBackground } from 'components/organisms/customer-portal/types/utils';
import { CpSectionWrapper } from '../../common';
import { CpVideosVariantWidgetProps } from '../types';

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  align-items: flex-start;
  overflow-y: hidden;
  gap: var(--cp-spacing-07);
`;

const TitleWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: var(--spacing-03);
`;

const Title = styled(CpHeading03Primary)`
  margin-bottom: 0;
`;

const Description = styled(CpBody03Placeholder)`
  margin-bottom: 0;
`;

const VideoDetails = styled.div`
  display: flex;
  gap: 16px;
  flex-direction: column;
  min-width: 35%;

  @media (max-width: 768px) {
    width: 30%;
  }

  @media (max-width: 480px) {
    width: 100%;
  }
`;

const VideoTitle = styled(CpBody03Primary)`
  margin-bottom: 0;
`;

const VideoDescription = styled(CpBody01Secondary)`
  margin-bottom: 0;
`;

const VideoSection = styled.div`
  display: flex;
  flex-direction: row;
  gap: 80px;
  justify-content: center;
  align-items: center;
  width: 100%;

  .videoPlayer {
    min-width: 620px;
    min-height: 400px;
  }

  @media (max-width: 768px) {
    .videoPlayer {
      min-width: 0;
      min-height: 0;
      width: 400px !important;
      height: 300px !important;
    }
  }

  @media (max-width: 480px) {
    flex-direction: column;
    gap: 24px;

    .videoPlayer {
      width: 100% !important;
      height: 250px !important;
      min-width: 0;
      min-height: 0;
    }
  }
`;

export const CpSingleVideo: React.FC<CpVideosVariantWidgetProps> = ({
  disabled,
  data,
  widget,
}) => {
  const background = useGetBackground(widget);

  return (
    <CpSectionWrapper
      paddingY={widget?.widgetDefinition?.styles?.paddingY as number}
      isDisabled={disabled}
      background={background}
      data-builder-mode-full-tile="true"
    >
      <Wrapper>
        <TitleWrapper>
          <Title autoAdjustColor>{data.title ?? 'Videos'}</Title>
          <Description autoAdjustColor>{data.description}</Description>
        </TitleWrapper>
        <VideoSection>
          <VideoDetails>
            <VideoTitle autoAdjustColor>
              {data?.resources?.[0]?.name}
            </VideoTitle>
            <VideoDescription autoAdjustColor>
              {data?.resources?.[0]?.description}
            </VideoDescription>
          </VideoDetails>

          <ReactPlayer
            url={data?.resources?.[0]?.imageLink}
            className="videoPlayer"
            controls
          />
        </VideoSection>
      </Wrapper>
    </CpSectionWrapper>
  );
};
